<template>
  <div class="mr-2">
    <v-layout row>
      <v-spacer/>
      <StatusUserProfileIconDialog/>
      <StatusLicenceIconDialog/>
      <StatusDataPrivacyIconDialog/>
      <StatusTermsAndConditionsIconDialog/>
      <StatusCommsGlobal/>
    </v-layout>
  </div>
</template>

<script>
import StatusUserProfileIconDialog from "@/frame/status/components/StatusUserProfileIconDialog";
import StatusDataPrivacyIconDialog from "@/frame/status/components/StatusDataPrivacyIconDialog";
import StatusLicenceIconDialog from "@/frame/status/components/StatusLicenceIconDialog";
import StatusTermsAndConditionsIconDialog from "@/frame/status/components/StatusTermsAndConditionsIconDialog";
import StatusCommsGlobal from "@/frame/status/components/StatusCommsGlobal";

export default {
  components: {
    StatusDataPrivacyIconDialog,
    StatusLicenceIconDialog,
    StatusTermsAndConditionsIconDialog,
    StatusCommsGlobal,
    // StatusAuthLevelFacilityIconDialog,
    StatusUserProfileIconDialog
  }
};
</script>
